import { useEffect } from 'react';
import type { BusEvent, Unsubscribe } from '../core/types';
import { useEventScope } from './useEventScope';

export function useBlockEvent(
  pattern: string | undefined,
  handler: (event: BusEvent) => void,
): void {
  const scope = useEventScope();

  useEffect(() => {
    if (!pattern || !scope) return;

    const unsub: Unsubscribe = scope.bus.subscribe(pattern, handler);
    return unsub;
  }, [pattern, handler, scope]);
}
